import { QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        const status = error.status;

        if (status >= 400 && status < 500) {
          return false;
        }

        return (status === 0 || status >= 500) && failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error.message.includes('Server')) {
        console.error('Server issue'); // TODO!
      }
    },
  }),
});
